'use client';
import Error from '@/assets/icons/defaultImage/error.svg';
import ErrorLocation from '@/assets/icons/ErrorLocation.svg';
import { useTranslation } from '@/i18n/client';
import {
  COMMON_EVENT_NAMES,
  commonBusinessLogger,
  PageName,
} from '@/utils/logger/instance/commonBusinessLogger';
import { Button } from '@mui/material';
import cn from 'clsx';
import { useEffect } from 'react';
import styles from './index.module.scss';

//页面样式
export enum PageNothingLayout {
  ROW = 'row',
  COLUMN = 'column',
}

export enum ICON_TYPE {
  DEFAULT = 'default',
  LOCATION = 'location',
}

interface TrackParms {
  'data-exp': string;
  'data-exptag-config': string;
}

interface LoggerInfo {
  page: PageName;
  logTitle?: string;
  message?: Record<string, string | number | boolean>;
}
interface LoadingIconProps {
  iconType?: ICON_TYPE;
  layout?: PageNothingLayout; // row | column
  text?: string;
  btnText?: string;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  title?: string;
  titleStyle?: React.CSSProperties;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clickTryAgain?: (...args: any[]) => void;
  defaultImageWidth?: number; // 默认图片宽度
  defaultImageHeight?: number; // 默认图片高度
  trackParms?: TrackParms;
  loggerInfo?: LoggerInfo; // 是否上报logger
}

const UKPageError = ({
  iconType = ICON_TYPE.DEFAULT,
  layout = PageNothingLayout.COLUMN,
  text,
  btnText,
  className,
  style,
  textStyle,
  title,
  titleStyle,
  clickTryAgain = () => window.location.reload(),
  defaultImageWidth = 120,
  defaultImageHeight = 120,
  trackParms,
  loggerInfo,
}: LoadingIconProps) => {
  const { t } = useTranslation();

  // const { exptag, exptagConfig, exptagJsonParam } = trackParms || {};
  // const expTagProps = exptag
  //   ? {
  //       exptag,
  //       'data-exptag-config': exptagConfig ? exptagConfig : undefined,
  //       'data-exptag-json-param': exptagJsonParam ? exptagJsonParam : undefined,
  //     }
  //   : {};

  useEffect(() => {
    if (loggerInfo && loggerInfo?.page) {
      console.log(loggerInfo?.logTitle || 'page-no-data', loggerInfo.message);
      commonBusinessLogger({
        eventName: COMMON_EVENT_NAMES.PAGE_ERROR_COMPONENT_SHOW,
        category: {
          page: loggerInfo?.page,
        },
        message: loggerInfo?.message,
      });
    }
  }, [loggerInfo]);

  const getIcon = () => {
    switch (iconType) {
      case ICON_TYPE.LOCATION:
        return <ErrorLocation width={defaultImageWidth} height={defaultImageHeight} />;
      default:
        return <Error width={defaultImageWidth} height={defaultImageHeight} />;
    }
  };

  return (
    <div className={cn(styles.pageError, className)} style={style}>
      <div className={cn(layout === PageNothingLayout.ROW ? styles.row : styles.column)}>
        {getIcon()}
        {title && (
          <span className={styles.pageErrorTitle} style={titleStyle}>
            {title}
          </span>
        )}
        <span className={styles.pageErrorText} style={textStyle}>
          {text ? text : t ? t('common.pageStatus.error') : ''}
        </span>
      </div>
      <div {...trackParms}>
        <Button className={styles.btn} variant='outlined' onClick={clickTryAgain}>
          {btnText ? btnText : t ? t('common.btnText.tryAgain') : ''}
        </Button>
      </div>
    </div>
  );
};

export default UKPageError;
